export const version = (): string => {
  return (process.env.VUE_APP_TAG_NAME === '' ? process.env.VUE_APP_COMMIT : process.env.VUE_APP_TAG_NAME) ?? 'DEV'
}
